$('.square.female').click(function(){
  $('.square.male img.check').hide();
  $('.square.female img.check').toggle();
});

$('.square.male').click(function(){
  $('.square.female img.check').hide();
  $('.square.male img.check').toggle();
});


$('.age .square.one').click(function(){
  $('.age .square.one img.check').toggle();
  $('.age .square.two img.check').hide();
  $('.age .square.three img.check').hide();
  $('.age .square.four img.check').hide();
});

$('.age .square.two').click(function(){
  $('.age .square.one img.check').hide();
  $('.age .square.two img.check').toggle();
  $('.age .square.three img.check').hide();
  $('.age .square.four img.check').hide();
});


$('.age .square.three').click(function(){
  $('.age .square.one img.check').hide();
  $('.age .square.two img.check').hide();
  $('.age .square.three img.check').toggle();
  $('.age .square.four img.check').hide();
});


$('.age .square.four').click(function(){
  $('.age .square.one img.check').hide();
  $('.age .square.two img.check').hide();
  $('.age .square.three img.check').hide();
  $('.age .square.four img.check').toggle();
});





$('.goal .square').click(function(){
  $('img.check',this).toggle();
});




$('.square.male').click(function(){
  $('.quizbox.one').hide();
  $('.quizbox.two').show();
  $('.continue.him').show();
   $('.continue.her').hide();
});


$('.square.female').click(function(){
  $('.quizbox.one').hide();
  $('.quizbox.two').show();
  $('.continue.him').hide();
   $('.continue.her').show();
});


$('.quizbox.one .skip').click(function(){
  $('.quizbox.one').hide();
  $('.quizbox.two').show();
});


$('.quizbox.two .skip').click(function(){
  $('.quizbox.two').hide();
  $('.quizbox.three').show();
});


$('.age .square').click(function(){
  $('.quizbox.two').hide();
  $('.quizbox.three').show();
});



